export default __webpack_public_path__ + "static/media/close_button.d328b2fa.png";